// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"141":"03ed498b","346":"e393ecdc","598":"66cf2ebe","703":"02fac1dd","787":"a227375f"}[chunkId] + ".chunk.js";
};